import React, { Component, memo } from "react";

import api from "../services/api";

class TypeaheadMunicipios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      isLoading: false,
      options: [],
      idEstado: '',
      value: '',
      error: ''
    };
    this.onChange = props.onChange;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.idEstado !== prevState.idEstado
      || nextProps.municipio !== prevState.value
      || nextProps.error !== prevState.error) {
      return {
        idEstado: nextProps.idEstado,
        value: nextProps.municipio,
        error: nextProps.error
      };
    }
    return null;
  }

  handleChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    if (this.state.value !== value) {
      this.setState({ value: value }, this.onChange(this.props.name, value));
      if (value.length >= 3) {
        this.loadMunicipios(value);
      } else {
        this.setState({ showDropdown: false });
      }
    }
  };

  setValue = (value) => {
    this.setState({
      value: value,
      showDropdown: false
    }, this.onChange(this.props.name, value));
  };

  loadMunicipios = (value) => {
    this.setState({ isLoading: true });
    let params = { municipio: value, limit: 8 };
    if (this.state.idEstado) params.idEstado = this.state.idEstado;

    api.get('/municipios', { params: params })
      .then(response => {
        this.setState({
          showDropdown: true,
          isLoading: false,
          options: response.data.municipios
        });
      })
      .catch(error => {
        this.setState({ isLoading: false });
      });
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.idEstado !== prevProps.idEstado) {
      this.setState({ value: '' });
    }
  };

  render() {
    const { showDropdown, options, value, error } = this.state;

    const highlightText = (text, string, key) => {
      const textCopy = text;
      text = text.toLowerCase();
      string = string.toLowerCase();
      const index = text.indexOf(string);
      if (index < 0) return string;
      const array = [];
      if (index > 0) array.push(textCopy.substring(0, index));
      array.push(<b key={key}>{textCopy.substr(index, string.length)}</b>);
      array.push(textCopy.substr(index + string.length));
      return array;
    };

    return (
      <div className={'typeahead' + (error ? ' is-invalid' : '')}>
        <input
          type="text"
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleChange}
          className={'form-control' +
            (this.props.size === 'sm' ? ' form-control-sm' : (this.props.size === 'lg' ? ' form-control-lg' : ''))}
          required={this.props.required}
          disabled={this.props.checkEstado && !this.props.idEstado ? true : false}
        />
        {
          (showDropdown && options.length) ? (
            <ul>
              {
                options.map((item, key) => (
                  <li key={key} onClick={() => this.setValue(item.municipio)}>
                    {highlightText(item.municipio, value, key)}
                  </li>
                ))
              }
            </ul>
          ) : null
        }
      </div>
    )
  }
}

export default memo(TypeaheadMunicipios);
